var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.268,
    height: 16.349,
    viewBox: "0 0 23.268 16.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M115.75-2077.946c-2.625-.123-5.251-.235-7.876-.376a3.858,3.858,0,0,1-2.254-.7,3.466,3.466,0,0,1-1.215-2.472,36.618,36.618,0,0,1,0-9.35,3.342,3.342,0,0,1,1.485-2.657,4.091,4.091,0,0,1,1.983-.517c2.25-.115,4.5-.272,6.752-.276,2.761-.005,5.522.119,8.283.208a10.65,10.65,0,0,1,1.656.206,2.816,2.816,0,0,1,2.372,2.3,21.969,21.969,0,0,1,.427,5.277c-.04,1.728-.16,3.46-.365,5.176a2.855,2.855,0,0,1-2.862,2.724c-2.439.18-4.885.255-7.328.369-.351.017-.7,0-1.054,0Zm-2.309-11.7v6.954l6.021-3.477Z",
    transform: "translate(-104.105 2094.295)",
    fill: "#f10042"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/video.icon.5483115ac3efa55003c1f5ed39f557e5.svg";
export { ForwardRef as ReactComponent };